<template>
  <div class="cabinet__pagination-wrapper">
    <div class="pagination pagination--left">
      <label
        class="pagination__label"
        for="page"
      >Страница</label>
      <input
        ref="input"
        v-model="value"
        type="number"
        :min="1"
        :max="pages"
        step="1"
        class="pagination__input"
        @keypress.enter="clickPage(value)"
        @blur="onBlurInput"
      >
      <p class="pagination__text">
        из
      </p>
      <p class="pagination__count">
        {{ pages }}
      </p>
      <div class="pagination__links">
        <span
          :aria-disabled="isLoading"
          class="pagination__link pagination__prev"
          :class="{ 'pagination__prev--disabled': currentPage <= 1 }"
          @click="clickPage(currentPage - 1)"
        />
        <span
          :aria-disabled="isLoading"
          class="pagination__link pagination__next"
          :class="{ 'pagination__next--disabled': currentPage >= pages }"
          @click="clickPage(currentPage + 1)"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "Pagination",
  props: ["pages", "currentPage", "isLoading"],
  emits: ["clickPage"],
  data() {
    return {
      value: 1,
    };
  },
  watch: {
    value: {
      handler() {
        if (this.value > this.pages) {
          this.value = this.pages;
        }
      },
    },
    currentPage() {
      this.value = this.currentPage;
    },
  },
  mounted() {
    this.value = this.currentPage;
  },
  methods: {
    clickPage(number) {
      if (number <= 0) {
        number = 1;
      }

      this.value = number;
      this.$emit("clickPage", number);
      this.$refs.input.blur()
    },

    onBlurInput() {
      if (this.value > this.pages) {
        this.value = this.pages;
      } else if (this.value <= 0) {
        this.value = 1;
      }
    }
  },
};
</script>

<style scoped></style>
